import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { AppContext } from '../window';
import { NotificationContext } from '../context/NotificationContext';
import { safeReturnPath } from '../utils/returnPath';

interface AuthRedirectProps {
    notificationMessage?: string;
}

/**
 * Component that checks if user is logged in and redirects them to /search,
 * or to the same-site path in the `returnUrl` query parameter (an expired
 * email link sends the guest to `/?login=1&returnUrl=/inbox/42`).
 * This should be included in every landing page
 */
const AuthRedirect: React.FC<AuthRedirectProps> = ({ notificationMessage }) => {
    const { user } = useContext(AppContext);
    const { addNotification } = useContext(NotificationContext);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (user) {
            // User is logged in, redirect to search
            if (notificationMessage) {
                addNotification({
                    level: 'info',
                    message: notificationMessage,
                    dismissible: true,
                    timeout: 5000
                });
            }
            const returnPath = safeReturnPath(new URLSearchParams(location.search).get('returnUrl'));
            navigate(returnPath ?? '/search');
        }
    }, [user]);

    // This component doesn't render anything
    return null;
};

export default AuthRedirect;